import { useState, useEffect } from 'react'

/**
 * Calculate items per row based on actual window width
 * Matches the CSS grid breakpoints in _product_grid_area.scss
 */
const useItemsPerRow = () => {
  const [itemsPerRow, setItemsPerRow] = useState(6)

  useEffect(() => {
    const calculateItemsPerRow = () => {
      const width = window.innerWidth

      if (width > 1920) {
        return 6
      }
      if (width > 1600) {
        return 5
      }
      if (width > 1280) {
        return 4
      }
      if (width > 960) {
        return 3
      }
      return 2
    }

    const handleResize = () => {
      setItemsPerRow(calculateItemsPerRow())
    }

    // Set initial value
    handleResize()

    // Update on window resize
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return itemsPerRow
}

export default useItemsPerRow
